import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 水务相关接口
 **********************************************************************************/
export default {

	//******************************************************************************************************************首页看板统计概况

	/**
	 * 获取水务的看板统计概况
	 * @param {String} :unitId
	 */
	getKanbanCountInfo(unitId, success, failure) {
		Axios.post('/waterAffairs/getKanbanCountInfo.do', {
			unitId,
		}, success, failure)
	},

	//******************************************************************************************************************减排量

	/**
	 * 获取减排量相关信息
	 * @param {String} :deviceNos 选中设备no,多个用逗号隔开
	 */
	getKanbanCountInfo(deviceNos, time1, time2, success, failure) {
		Axios.post('/waterAffairs/getEmissionReductionInfo.do', {
			deviceNos,
			time1,
			time2,
		}, success, failure)
	},

	//******************************************************************************************************************工艺

	/**
	 * 获取单位下工艺列表
	 * @param {String} :unitId
	 */
	getUnitTechnologyList(unitId, success, failure) {
		Axios.post('/waterAffairs/getUnitTechnologyList.do', {
			unitId,
		}, success, failure)
	},
	/**
	 * 添加或更新工艺
	 * @param {Long} :pkid 主键
	 * @param {Long} :name 工艺名称
	 * @param {Long} :type 工艺类型 下拉框 具体数据见yapi
	 * @param {Long} :unitId 单位id
	 * @param {String} :deviceNos 工艺绑定设备no,多个用逗号隔开
	 */
	saveTechnology(pkid, name, type, unitId, deviceNos, success, failure) {
		Axios.post('/waterAffairs/saveTechnology.do', {
			pkid,
			name,
			type,
			unitId,
			deviceNos
		}, success, failure)
	},
	/**
	 * 删除工艺
	 * @param {Long} :pkid 主键
	 */
	deleteTechnology(pkid, success, failure) {
		Axios.post('/waterAffairs/deleteTechnology.do', {
			pkid
		}, success, failure)
	},
	/**
	 * 获取工艺概况
	 * @param {Long} :pkid 主键
	 */
	getTechnologyInfo(pkid, success, failure) {
		Axios.post('/waterAffairs/getTechnologyInfo.do', {
			pkid
		}, success, failure)
	},

	//******************************************************************************************************************员工

	/**
	 * 获取员工列表
	 * @param {String} :unitId
	 * @param {String} :rfid 员工编号 非必填 搜索过滤用
	 * @param {String} :name 员工姓名 非必填 搜索过滤用
	 * @param {String} :department 员工部门 非必填 搜索过滤用
	 * @param {String} :gender 性别 非必填 搜索过滤用
	 */
	getStaffLimit(unitId, rfid, name, department, gender, pageIndex, pageSize, success, failure) {
		Axios.post('/waterAffairs/getStaffLimit.do', {
			unitId,
			rfid,
			name,
			department,
			gender,
			pageIndex,
			pageSize
		}, success, failure)
	},
}